import { configureStore } from "@reduxjs/toolkit";
// settings
import settings from "../features/settings/Slice";
// auth
import auth from "../features/auth/Slice";
// serviceadmin
import serviceadmin from "./serviceadmin";
// import masters from "./masters";

// Transaction History
import transaction_history from "./transaction_history";

// Dashboard
import dashboard from "./dashboard";

// common
import common from "../features/serviceadmin/common/Slice";

// Notification
import notification from "./notification";

// pick_drop_charges
import pick_drop_charges from "./pick_drop_charges";

export const store = configureStore({
  reducer: {
    // settings
    settings: settings,

    //auth
    auth: auth,

    //serviceadmin
    serviceadmin: serviceadmin,

    //common
    common: common,

    // transaction_history
    transaction_history: transaction_history,

    // dashboard
    dashboard: dashboard,

    // notification
    notification: notification,

    // pick_drop_charges
    pick_drop_charges: pick_drop_charges,
  },
});
